import Component from '../app/component';
import tweens from '../helpers/tweens';

export default class extends Component {
  constructor(el) {
    super(el);
    this.data = {};
  }

  init() {
    if (this.refs.products.length) {
      this.refs.products.forEach((el) => {
        const productImageEl = el.querySelector('.related-image');
        const overImageEl = el.querySelector('.related-over-image');
        if (productImageEl) {
          productImageEl.addEventListener('mouseenter', () => {
            document.body.dispatchEvent(new CustomEvent('cursor.display'));
            if (overImageEl) {
              overImageEl.src = overImageEl.src.replace(/\.png$/i, '.gif');
            }
          });
          productImageEl.addEventListener('mouseleave', () => {
            document.body.dispatchEvent(new CustomEvent('cursor.hide'));
            if (overImageEl) {
              overImageEl.src = overImageEl.src.replace(/\.gif$/i, '.png');
            }
          });
          productImageEl.addEventListener('mousedown', () => {
            document.body.dispatchEvent(new CustomEvent('cursor.click'));
          });
          productImageEl.addEventListener('mouseup', () => {
            document.body.dispatchEvent(new CustomEvent('cursor.unclick'));
          });
        }
      });
    }
    this.tweenBottles();
  }

  tweenBottles() {
    if (!this.refs?.bottles?.length) {
      return;
    }
    this.refs.bottles.forEach((el) => {
      tweens.tweenFloat(el);
    });
  }
}
